import { IconProps } from '@/types/icon';

interface FacebookIconPropsType {
  colorLogo: string;
}

export function IconeFacebook({
  size,
  color,
  colorLogo,
  ...props
}: IconProps & FacebookIconPropsType) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="facebook"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 26"
      width={size}
      height={size}
      {...props}
    >
      <rect
        x="0.03125"
        y="0.826172"
        width="24.8969"
        height="24.8969"
        rx="4.97938"
        fill={color}
      />
      <path
        d="M18.7021 2.90039H15.59C14.2143 2.90039 12.895 3.44686 11.9223 4.41959C10.9496 5.39231 10.4031 6.71161 10.4031 8.08725V11.1994H7.29102V15.3488H10.4031V23.6478H14.5526V15.3488H17.6647L18.7021 11.1994H14.5526V8.08725C14.5526 7.81212 14.6619 7.54826 14.8565 7.35371C15.051 7.15917 15.3149 7.04988 15.59 7.04988H18.7021V2.90039Z"
        fill={colorLogo}
      />
    </svg>
  );
}
